// migrations/3_addProductLocation.js
import { collection, getDocs, updateDoc, doc } from "firebase/firestore";
import { db } from "../../../firebase/firebase";

const migration3 = {
  version: 3,
  name: "addProductLocation",

  run: async () => {
    console.log("Running migration: addProductLocation");

    const productsSnap = await getDocs(collection(db, "products"));
    let count = 0;

    for (const product of productsSnap.docs) {
      const id = product.id;
      const data = product.data();

      const category = (data.category || "").toLowerCase();

      let location = null;

      // Coloring Books
      if (category === "coloring-books" || category === "coloring") {
        location = `https://flickerbound.com/shop/coloring-books/${id}`;
      }

      // Journals
      else if (category === "journals" || category === "journal") {
        location = `https://flickerbound.com/shop/journals/${id}`;
      }

      // Fallback (if you add more categories later)
      else {
        location = `https://flickerbound.com/products/${id}`;
      }

      await updateDoc(doc(db, "products", id), { location });

      console.log(`Updated product ${id} → ${location}`);
      count++;
    }

    console.log(`✔ Migration complete. Updated ${count} products.`);
  }
};

export default migration3;
